import validator from './validator';

const strings = {
  required: validator(
    v => (v || '').trim() !== '',
    'validation.strings.required'
  )
};

export default strings;
